import { registerComponent } from '@gig/magic-common';
import QuestionnairesComponent from './questionnaires.vue.js';

var Questionnaires = registerComponent(QuestionnairesComponent);

export { Questionnaires };
